import TestCard from './TestCard';

export default TestCard;
